export const SET_SEARCH_RESULTS = 'SET_SEARCH_RESULTS'

export const setSearchResults = searchResults => {
  return dispatch => {
    dispatch({ type: SET_SEARCH_RESULTS, payload: searchResults })
  }
}